import React, { useEffect, useRef } from "react"
import { navigate } from "gatsby"
import { useLocation } from "@reach/router"

const cleanPath = p => (p || "").split("?")[0].split("#")[0].replace(/\/$/, "") || "/"

const setTransitionTitle = (val) => {
  const el = document.querySelector(".page--title .title")
  if (!el) return
  el.textContent = val || ""
}

const PageTransition = ({ children }) => {
  const transitionRef = useRef(null)
  const { pathname } = useLocation()

  useEffect(() => {
    const transitionWrapper = transitionRef.current
    if (!transitionWrapper) return
    const transitionDuration = window.innerWidth < 768 ? 500 : 950
    function fadeOutPage(event, path, linkEl) {
      const current = cleanPath(pathname)
      const next = cleanPath(path)
      if (current === next) return
      event.preventDefault()
      setTransitionTitle(linkEl?.getAttribute("data-title") || "")
      document.body.classList.add('in-transition')
      transitionWrapper.classList.remove("fade--in")
      transitionWrapper.classList.add("fade--out")

      setTimeout(() => {
        window.scrollTo(0, 0)
        navigate(path)
      }, transitionDuration)
    }

    function fadeInPage() {
      if (!window.location.hash) window.scrollTo(0, 0)
      document.body.classList.remove("menu-open")
      document.body.classList.remove('in-transition');
      document.querySelector('.mobile-menu--button').innerHTML ='Menu';
      transitionWrapper.classList.remove("fade--out")
      transitionWrapper.classList.add("fade--in")
    }

    fadeInPage()

    const links = document.querySelectorAll("a")
    const handlers = new Map()

    links.forEach(link => {
      if (link.hasAttribute("target")) return

      const path = link.getAttribute("href")
      if (!path) return

      const handler = (e) => fadeOutPage(e, path, link)
      handlers.set(link, handler)
      link.addEventListener("click", handler)
    })

    return () => {
      links.forEach(link => {
        const handler = handlers.get(link)
        if (handler) link.removeEventListener("click", handler)
      })
    }
  }, [pathname])

  return (
    <div className="page--transition fade--in" ref={transitionRef}>
      {children}
    </div>
  )
}

export default PageTransition
